module.exports = __webpack_public_path__ + "img/caret_gray_down.svg";